import axios from 'axios';

export const state = {};

export const getters = {};

export const mutations = {};

export const actions = {
    async index(vuexContext, dateRange) {
        const [startDate, endDate] = dateRange;

        const { data } = await axios.get('/dashboard', {
            params: {
                startDate,
                endDate
            }
        });

        return data;
    }
};
